/**
 * Supabase Client — Verbindung zur Gutachter KOOP Datenbank
 * Projekt: MietGo / Gutachter KOOP (ytwxlbpjsjseaqhvyvlh)
 * 
 * DESIGN: Reduzierte Farben. Alle Status-Badges dezent grau.
 * Nur "dringend" bekommt leichtes Rot.
 */

import { createClient } from '@supabase/supabase-js';

export const SUPABASE_URL = import.meta.env.VITE_SUPABASE_URL;
if (!SUPABASE_URL) throw new Error('VITE_SUPABASE_URL ist nicht gesetzt — bitte in .env.local oder den Vercel-Umgebungsvariablen eintragen');
export const SUPABASE_ANON_KEY = import.meta.env.VITE_SUPABASE_ANON_KEY;
if (!SUPABASE_ANON_KEY) throw new Error('VITE_SUPABASE_ANON_KEY ist nicht gesetzt — bitte in .env.local oder den Vercel-Umgebungsvariablen eintragen');

export const supabase = createClient(SUPABASE_URL, SUPABASE_ANON_KEY, {
  auth: {
    autoRefreshToken: true,
    persistSession: true,
    detectSessionInUrl: true,
  },
});

// Type helpers — alle 7 Betriebe
export type BusinessUnit = 'gutachten' | 'autoglas' | 'mietwagen' | 'werkstatt' | 'protex' | 'unfallgiganten' | 'airbnb';
export type AktenStatus = 'neu' | 'in_bearbeitung' | 'warten' | 'abgeschlossen' | 'storniert';
export type Prioritaet = 'niedrig' | 'mittel' | 'hoch' | 'dringend';
export type AufgabenStatus = 'offen' | 'in_bearbeitung' | 'erledigt' | 'abgebrochen';
export type RechnungsStatus = 'entwurf' | 'gesendet' | 'bezahlt' | 'ueberfaellig' | 'storniert';

// Status display helpers
export const STATUS_LABELS: Record<AktenStatus, string> = {
  neu: 'Neu',
  in_bearbeitung: 'In Bearbeitung',
  warten: 'Wartend',
  abgeschlossen: 'Abgeschlossen',
  storniert: 'Storniert',
};

/** Dezente Status-Farben: Hellgrauer Hintergrund + dunkler Text */
export const STATUS_COLORS: Record<AktenStatus, string> = {
  neu: 'bg-gray-100 text-gray-600',
  in_bearbeitung: 'bg-gray-100 text-gray-700',
  warten: 'bg-gray-100 text-gray-500',
  abgeschlossen: 'bg-gray-100 text-gray-500',
  storniert: 'bg-gray-50 text-gray-400',
};

/** Dezente Priorität-Farben: Nur "dringend" bekommt leichtes Rot */
export const PRIORITAET_COLORS: Record<Prioritaet, string> = {
  niedrig: 'bg-gray-100 text-gray-500',
  mittel: 'bg-gray-100 text-gray-600',
  hoch: 'bg-gray-100 text-gray-700',
  dringend: 'bg-red-50 text-red-700',
};

/** Dezente Rechnungs-Status-Farben */
export const RECHNUNGS_STATUS_COLORS: Record<RechnungsStatus, string> = {
  entwurf: 'bg-gray-100 text-gray-500',
  gesendet: 'bg-gray-100 text-gray-600',
  bezahlt: 'bg-gray-100 text-gray-600',
  ueberfaellig: 'bg-red-50 text-red-700',
  storniert: 'bg-gray-50 text-gray-400',
};
